import ProductSlateShippingSection from './ProductSlateShippingSection'

export default ProductSlateShippingSection
